import React, { useState, useEffect } from 'react';

const SpeechSummaryPopup = ({ isOpen, onClose, summary, loading, onGenerateSummary }) => {
  const [customPrompt, setCustomPrompt] = useState('');
  
  // Reset customPrompt when popup opens
  useEffect(() => {
    if (isOpen) {
      setCustomPrompt('');
    }
  }, [isOpen]);
  
  if (!isOpen) return null;

  const handleGenerateSummary = () => {
    onGenerateSummary(customPrompt);
  };

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 dark:bg-black/70 flex items-center justify-center z-[1000]">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md w-[90%] max-w-3xl max-h-[80vh] overflow-auto transition-colors duration-200">
        <div className="p-4 px-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
          <h2 className="text-xl font-semibold m-0 text-gray-900 dark:text-white">Speech Summary</h2>
          <button 
            onClick={onClose}
            className="bg-transparent border-0 cursor-pointer text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="p-4 px-6">
          {!summary && !loading ? (
            <div>
              <div className="mb-4">
                <label 
                  htmlFor="customPrompt" 
                  className="block mb-2 font-medium text-gray-700 dark:text-gray-300"
                >
                  Customize your summary request:
                </label>
                <textarea
                  id="customPrompt"
                  value={customPrompt}
                  onChange={(e) => setCustomPrompt(e.target.value)}
                  placeholder="E.g., Focus on economic arguments, Summarize the main points of disagreement, etc."
                  className="w-full p-3 rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 min-h-[100px] font-sans text-sm leading-normal resize-y focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div className="flex justify-end">
                <button
                  onClick={handleGenerateSummary}
                  className="bg-primary text-white font-medium py-2 px-4 rounded border-0 cursor-pointer inline-flex items-center transition hover:bg-primary-dark"
                >
                  Generate Summary
                </button>
              </div>
            </div>
          ) : loading ? (
            <div className="flex justify-center items-center py-8">
              <div className="modern-spinner"></div>
              <span className="ml-3 text-gray-900 dark:text-white">Generating summary...</span>
            </div>
          ) : (
            <div>
              <div className="leading-relaxed text-gray-700 dark:text-gray-300 p-4 bg-gray-50 dark:bg-gray-700 rounded mb-4 whitespace-pre-wrap">
                {summary}
              </div>
              <div className="flex justify-end">
                <button
                  onClick={() => {
                    setCustomPrompt('');
                    onGenerateSummary('');
                  }}
                  className="bg-secondary text-white font-medium py-2 px-4 rounded border-0 cursor-pointer inline-flex items-center transition hover:bg-secondary-dark"
                >
                  Generate New Summary
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SpeechSummaryPopup;
